import controller from '../../../cases/fill/fill.controller';
import template from '../../../cases/fill/fill.pug';

const PublicFillSubCaseComponent = {
  template,
  controller,
  bindings: {
    subCase: '<',
  },
};

export default PublicFillSubCaseComponent;



// WEBPACK FOOTER //
// ./client/app/public/case/fillSubCase/fillSubCase.component.js